import directives from "./permission/buttonPower";

export default {
    install(app) {
        Object.keys(directives).forEach((keys) => {
            app.directive(keys,directives[keys]);
        })
    }
}
